import { ApiV4Enum } from '../v4/generic'

export interface ICardItem {
  id: string
  lastDigits: string
  expiry: string
  brand: string
}

interface IBackendCardItem {
  paymentMethodId: string
  brand: ApiV4Enum
  country: string
  funding: ApiV4Enum
  lastDigits: string
  expiryMonth: number
  expiryYear: number
}

export class CreditCardsAdapter {
  static convertResponse(data: Array<IBackendCardItem>): Array<ICardItem> {
    if (!data) return []

    return data.map((ccData: IBackendCardItem) => {
      return {
        id: ccData.paymentMethodId,
        lastDigits: ccData.lastDigits,
        expiry: `${('0' + ccData.expiryMonth).slice(-2)} / ${ccData.expiryYear}`,
        brand: ccData.brand?.label ?? String(ccData.brand),
      }
    })
  }
}
